export default {"src":"/_next/static/media/hsn-Finder-icon.795e44ca.svg","height":26,"width":26};